import React, { useCallback, useState, useEffect } from 'react';
import { Redirect, useHistory, useRouteMatch, useLocation, Route } from 'react-router-dom';
import { Layout, message } from 'antd';

import LevelUpHeader from 'src/components/Header/LevelUpHeader';
import Navigation from 'src/components/Navigation';
import Loading from 'src/components/common/Loading';

import { useQueryProxy } from 'src/operations/proxy/user';
import { USER_ME } from 'src/operations/queries/getUser';
import { isLogedIn, userInfoVar } from 'src/apollo/cache';
import { getCurrentToken } from '../utils';
import { storage } from 'src/utils/hooks';
import { useAuthCheck } from 'src/utils/hooks';
import { useApolloClient, useQuery } from '@apollo/client';
import jwtDecode from 'jwt-decode';
import { useSelector } from 'react-redux';
import { classStoreData } from 'src/operations/store';
import { useStudentStudyAccessCheck } from 'src/utils/hooks';
const { Content } = Layout;

function useQueryParams() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function DefaultLayout({
  component: Component,
  logOut,
  isHeaderStatic = false,
  closeHeader = false,
  hideMenu = false,
  removeMargin = false,
  ...rest
}) {
  const { isLevelUp } = useStudentStudyAccessCheck();
  const companyName = useSelector(classStoreData);
  const history = useHistory();
  const location = useLocation();
  const queryParams = useQueryParams();
  const token = getCurrentToken();
  const client = useApolloClient();
  const [loaded, setLoaded] = useState(false);
  const { pathname } = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  const { loading, data, error } = useQueryProxy(USER_ME, {
    variables: { token },
    skip: !token,
  });

  useEffect(() => {
    if (error) {
      isLogedIn(false);
      if (location.pathname !== '/login') {
        history.replace('/login');
      }
      setLoaded(true);
    }
  }, [error, history, location.pathname]);

  useEffect(() => {
    if (!isLogedIn() || !token) {
      if (location.pathname !== '/login') {
        history.replace('/login');
      }
    }
  }, [history, token, location.pathname]);

  useEffect(() => {
    if (data?.me) {
      userInfoVar(data?.me);
      setLoaded(true);
    } else if (token) userInfoVar(jwtDecode(token));
  }, [data, loading, token]);

  const onCollapse = useCallback(() => {
    setCollapsed((prev) => !prev);
  }, []);

  const matchTest = useRouteMatch(['/test/new/:id/:type']);
  useEffect(() => {
    //placement test 용으로 로그인했을 경우, 시험보는 페이지가 아니면 로그아웃 처리한다.
    if (!matchTest && data?.me?.level_test === 1) {
      isLogedIn(false);
      userInfoVar(null);
      client.clearStore();
      client.cache.gc();
      storage.removeItem('culp_token');
      //history.replace('/level-test');
      //return <Redirect to={`/level-test`} />;
    }
  }, [data, matchTest, client]);

  const { isAccepted } = useAuthCheck();

  useEffect(() => {
    if (isLevelUp === false && pathname.includes('level-up') && data?.me?.type === 0) {
      if (companyName === 'englishtap' || companyName === 'english42') {
        return history.replace('/');
      }
      history.replace('/no-access');
    }
  }, [history, isLevelUp, data, companyName, pathname]);

  if (isAccepted === false) {
    return <Redirect path="/" />;
  }

  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <>
          {loading || !loaded ? (
            <Loading />
          ) : (
            <Layout className="level-up-layout">
              {collapsed && <Navigation />}

              <Layout className="main-layout">
                {!queryParams.get('removeHeader') ? (
                  <LevelUpHeader
                    collapsed={collapsed}
                    onCollapse={onCollapse}
                    isStatic={isHeaderStatic}
                    closeHeader={closeHeader}
                    hideMenu={hideMenu}
                  />
                ) : null}
                <Content style={removeMargin ? {} : { margin: '0 16px' }}>
                  <Component {...matchProps} {...rest} />
                </Content>
              </Layout>
            </Layout>
          )}
        </>
      )}
    />
  );
}

export default DefaultLayout;
